<template>
  <div>
    <div class="px-4 py-6" style="background: #FFF;">
      <iframe
        v-if="userDetails.tipaltiDetails.publisherDetails"
        :src="userDetails.tipaltiDetails.publisherDetails"
        height="800"
        width="800"
        style="border: none;"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      userDetails: this.user
    }
  },
  watch: {},
  computed: {},
  methods: {},
  mounted() {},
  updated() {}
}
</script>
<style scoped></style>
